import type { LevelDefinition } from "@/domain";

import type {
  HabitsPlayerActivityType,
  HabitsPlayerLevel
} from "./types";

export function requirePlayerMedia<TPayload>(
  level: LevelDefinition<TPayload>
): HabitsPlayerLevel<TPayload> {
  const promptAudio = level.promptAudio;
  const sceneImagePath = level.assets[0];

  if (promptAudio === undefined) {
    throw new Error("Level " + level.id + " must declare instruction audio");
  }

  if (sceneImagePath === undefined) {
    throw new Error("Level " + level.id + " must declare a scene image");
  }

  return {
    ...level,
    promptAudio,
    assets: [sceneImagePath, ...level.assets.slice(1)]
  };
}

export function requireActivityType(
  level: LevelDefinition,
  expected: HabitsPlayerActivityType
): void {
  if (level.activityType !== expected || level.domain !== "habits") {
    throw new Error(
      "Level " + level.id + " is not a Habits " + expected + " level"
    );
  }
}

export function requireHabitsAudioPath(
  audioPath: string | undefined,
  levelId: string,
  description: string
): string {
  if (audioPath === undefined) {
    throw new Error(
      "Level " + levelId + " must declare audio for " + description
    );
  }

  return audioPath;
}
